'use strict';

//import 'jquery';
var $ = require('jquery');
window.jQuery = $;
import './assets/css/inspinia.css';
require('./assets/css/style.css');
import './assets/css/animate.css';
import './assets/js/plugins/gritter/jquery.gritter.css';
import './assets/css/plugins/chosen/chosen.css';
import './assets/css/plugins/iCheck/custom.css';
import './assets/lib/metisMenu/dist/metisMenu.min.css';
import './assets/lib/metisMenu/dist/metisMenu.min.js';

import 'metismenu';
import 'angular-flot';

import './assets/js/plugins/slimscroll/jquery.slimscroll.min.js';
import './assets/js/plugins/peity/jquery.peity.min.js';
import './assets/js/demo/peity-demo.js';
import './assets/js/inspinia.js';
import './assets/js/plugins/pace/pace.min.js';
import './assets/js/plugins/gritter/jquery.gritter.min.js';
import './assets/js/plugins/sparkline/jquery.sparkline.min.js';
import './assets/js/demo/sparkline-demo.js';
import './assets/js/plugins/jasny/jasny-bootstrap.min.js';
// import './assets/js/plugins/iCheck/icheck.min.js';
import './assets/js/plugins/chosen/chosen.jquery.js';
import './assets/js/plugins/nestable/jquery.nestable.js';
//import './assets/js/angular-drag-and-drop-lists.js';



// WEBPACK FOOTER //
// ./packages/custom/inspinia/public/index.js